import styles from "./FocusTrap.module.css";
type CoreFocusTrapProps = {
	onFocus: () => void;
};

export default function CoreFocusTrap({ onFocus, ...props }: CoreFocusTrapProps) {
	return <div tabIndex={0} className={styles["core-focus-trap"]} onFocus={onFocus} {...props} />;
}
